<template>
  <div
    :style="{zIndex:zIndex,'min-height':height+'px'}"
    :class="stickyClass"
  >
    <div
      :class="className"
      :style="{top:stickyTop+'px',zIndex:zIndex,position:position,left:cssLeftAttributeVal,right:cssRightAttributeVal,width:width}"
    >
      <div :class="[{ row: active, 'align-center': active }]">
        <div :class="[{ 'sticky-content': active, 'medium-12': active, 'small-12': active, columns: active, 'large-12': active }]">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/utils/eventBus'

export default {
  name: 'StickyHeader',
  props: {
    stickyTop: {
      type: Number,
      default: 0,
    },
    zIndex: {
      type: Number,
      default: 100,
    },
    className: {
      type: [Array, Object],
      default: () => [],
    },
    isStickyHeader: {
      type: Boolean,
    },
    extendStickyClass: {
      type: String,
      default: '',
    },
    fullWidth: {
      type: Boolean,
      default: true,
    },
    specifyWidth: {
      type: String,
      default: '',
    },
    align: {
      type: String,
      default: 'left',
    },
  },
  data () {
    return {
      active: false,
      position: '',
      currentTop: '',
      width: undefined,
      height: undefined,
      child: null,
      stickyHeight: 0,
      innerIsStickyHeader: false,
      stickyClass: '',
    }
  },
  computed: {
    cssLeftAttributeVal () {
      return this.align === 'left' ? 0 : undefined
    },
    cssRightAttributeVal () {
      return this.align === 'right' ? 0 : undefined
    },
  },
  watch: {
    innerIsStickyHeader () {
      this.$emit('input', this.innerIsStickyHeader)
    },
  },
  mounted () {
    this.height = this.$el.getBoundingClientRect().height
    window.addEventListener('scroll', this.handleScroll)
    EventBus.on('window_scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
    EventBus.off('window_scroll', this.handleScroll)
  },
  methods: {
    sticky () {
      if (this.active) {
        this.innerIsStickyHeader = true
        return
      }
      this.position = 'fixed'
      this.active = true
      this.width = this.fullWidth ? '100%' : '30%'
      this.stickyClass = this.extendStickyClass
      if (this.specifyWidth) {
        this.width = this.specifyWidth
      }
    },
    reset () {
      if (!this.active) {
        return
      }
      this.innerIsStickyHeader = false
      this.position = ''
      this.width = 'auto'
      this.active = false
      this.stickyClass = ''
    },
    handleScroll () {
      const elRect = this.$el.getBoundingClientRect()
      const isNotVisible = elRect.top === 0 && elRect.x === 0 && elRect.y === 0
      if (isNotVisible) {
        this.reset()
        return
      }
      if (elRect.top < this.stickyTop) {
        this.sticky()
        return
      }
      this.reset()
    },
  },
}
</script>
